import React, { useState } from "react";
import "./Nav.css";
import styled from "styled-components";
import { Clear } from "@material-ui/icons";
import { MenuRounded } from "@material-ui/icons";
import { useHistory } from "react-router";




function Nav({ img_logo1, img_logo2 }) {
  const [burgerStatus, setBurgerStatus] = useState(false)
  const history = useHistory();
  return (
    <div className="nav">
      <div className="nav__left">

        <img className="img_logo1" src={img_logo1} alt="" />


        <img onClick={() => history.push('/')} className="img_logo2" src={img_logo2} alt="" />

      </div>
      <div className="nav__mid">
        <div className="nav__mid__all">

          <div className="right_menu">
            <a className="menu_button">MODES</a>
            <div className="dropdown_menu">
              <p >BATTLE ROYALE</p>
              <p>CREATIVE </p>
              <p>SAVE THE WORLD</p>
            </div>
          </div>

          <li onClick={() => history.push('/battlePass')}>BATTLE PASS</li>
          <li onClick={() => history.push('/crew')} >CREW</li>
          <li>V-BUCKS</li>
          <li>COMPETITIVE</li>
          <li>NEWS</li>
          <li>MERCH</li>
          <li>COSPLAY</li>
          <li>HELP</li>

        </div>
      </div>

      <div className="nav__right">
        <div className="nav__right__icons">
          <i class="fas fa-search"></i>
        </div>

        <div className="right_menu__ONE">
          <a className="menu_button__globe">
            <i class="fas fa-globe"></i>
          </a>
          <div className="dropdown_menu__ONE">
            <p>ENGLISH</p>
            <p>العربية </p>
            <p>DEUTSCH </p>
            <p>ESPAÑOL (SPAIN) </p>
            <p>ESPAÑOL (LA) </p>
            <p>FRANÇAIS </p>
            <p>POLSKI </p>
            <p>日本語 </p>
            <p>ITALIANO </p>
            <p>TÜRKÇE </p>
            <p>PORTUGUÊS (BRASIL) </p>
            <p>한국어 </p>
            <p>РУССКИЙ</p>
          </div>
        </div>

        <div className="nav__right__icons">
          <i class="fas fa-user-astronaut"></i>
        </div>

        <div className="nav__right__sign">
          <a href="/sign">Sign In</a>
        </div>

        <button className="nav__right__btn">DOWNLOAD</button>
      </div>
      <CustomMenu onClick={() => setBurgerStatus(true)} />

      <BurgerNav show={burgerStatus}>
        <CloseWrapper>
          <CustomClear onClick={() => setBurgerStatus(false)} />
        </CloseWrapper>

        <Des>
          <li><a href="/">HOME</a></li>
          <li><a href="/battlePass">BATTELE PASS</a></li>
          <li><a href="/crew">CREW</a></li>
          <li><a href="#">MODES</a></li>
          <li><a href="#">SAVE THE WORLD</a></li>
          <li><a href="#">BATTLE PASS</a></li>
          <li><a href="#">CREATIVE</a></li>
          <li><a href="#">V-BUCKS</a></li>
          <li><a href="#"> COMPETITIVE</a></li>
          <li><a href="#">MERCH</a></li>
          <li><a href="#">COSPLAY</a></li>
          <li><a href="#">HELP</a></li>



          <textarea name="" id="" cols="30" rows="10" placeholder="Search...">
          </textarea>
        </Des>

        <NavBorder />
        <div className="Burger__icons">
          <div className="burgerNav__astronaut">
            <i class="fas fa-user-astronaut"></i>
          </div>

          <div className="burgerNav__signIn">
            <a href="/sign">SIGN IN</a>
          </div>
          <a className="burgerNav__globe">
            <i class="fas fa-globe"></i>
          </a>
        </div>
        <div className="burgerNav__info">
          <p>Fortnite is an online video game developed by Epic Games and released in 2017. It is available in three distinct game mode versions that otherwise share the same general gameplay and game engine: ...</p>
        </div>

        <div className="burger__end">

          <i class="fab fa-playstation"></i>

          <i class="fab fa-xbox"></i>

          <i class="fas fa-gamepad"></i>

          <i class="fab fa-studiovinari"></i>


          <i class="fab fa-gulp"></i>

          <i class="fab fa-grunt"></i>
        </div>
      </BurgerNav>

    </div>
  );
}

export default Nav;





const BurgerNav = styled.div`
overflow-x: scroll;
::-webkit-scrollbar{
  width: 0;
}
position:fixed;
top:0;
right:0;
bottom:0;
background: #2f2f2f;
width:300px;
z-index:16;
list-style: none;
padding:20px;
display:flex;
flex-direction: column;
text-align:start;
transition: transform 0.6s ease-in-out;
transform: ${props => props.show ? 'translateX(0)' : 'translateX(100%)'};


li{
    padding:15px 0;
    border-bottom:1px solid #484545;
  }
  a{
    font-weight:600;
    color:white;
    text-decoration:none;
    transition: all 0.3s ease-in-out;
    border:1px solid #;

    &:hover{
        color:yellow;
        cursor:pointer;

        @media (max-width: 600px) {
          width: 100%;
          
        }
    }
}
`

const Des = styled.div`
background-color: #2f2f2f;

p{
    text-transform: uppercase;
font-size: 1rem;
line-height: 1;
font-weight: 500;
padding:20px;
letter-spacing:2px;
line-height:22px;

}
h6{
    text-transform: uppercase;
    font-size: 1rem;
    line-height: 1;
    font-weight: 500;
    padding:20px;
    letter-spacing:2px;
    opacity:0.8;
}
textarea{
    margin-top: 0px;
    margin-bottom: 0px;
    height: 65px;
    margin-left: 10px;
    padding:10px;
    font-size:16px;
    opacity:0.7;
    margin-top: 24px;
    margin-bottom: 0px;
    height: 65px;
    width: 367px;
    margin-left: -1px;
    padding: 19px;
    font-size: 16px;
    opacity: 0.7;
    background: transparent;
    border-radius: 6px;
    outline:none;
    color:white;

    @media (max-width: 600px) {
        width: 265px;
        
      }
}
h5{
    text-align:center;
    align-items:center;
    opacity:0.7;
    text-transform: uppercase;
  
}
&:hover{
    h5{
        color:black;
        cursor:pointer;
    }
}
`

const CustomMenu = styled(MenuRounded)`
color:white;
cursor:pointer;
margin-top: 30px;
margin-left: 5px;
  visibility: hidden;
  display:none;

  @media (max-width: 600px) {
    display:flex;
    visibility: visible;

  }
`

const CustomClear = styled(Clear)`
color:white;
cursor:pointer;
`
const CloseWrapper = styled.div`
display:flex;
justify-content: flex-end;
`

const NavBorder = styled.div`
  border-bottom:1px solid #484545;
  margin-top:20px;
`